import { notification } from "antd";
import { ReactNode } from "react";

type NotificationType = "error" | "success" | "info" | "warning" | "open";

export const message = (type: NotificationType, text: ReactNode, description?: string, duration = 5) => {
  return notification[type]({ message: text, description, duration, top: 70 });
};
